import type { LegacyRef, ReactNode } from 'react';
import { Component } from 'react';

import BpkCard from '@skyscanner/backpack-web/bpk-component-card';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { Nullable } from '@shared/types/utils';

import STYLES from './CardWrapper.module.scss';

import ResponsibleImage from '@hotels-hotel-detail/ui/ResponsibleImage';
import { TABLET_WIDTH } from '@hotels-hotel-detail/ui/ResponsibleImage/media-width';

const cls = cssModules(STYLES);

type Props = {
  isSelected: boolean;
  image: Nullable<string>;
  refCallback?: LegacyRef<HTMLDivElement>;
  onClick?: () => void;
  onMouseEnter?: Function;
  onMouseLeave?: Function;
  children?: ReactNode;
  href?: Nullable<string>;
  className?: string;
  isLast?: boolean;
};

const defaultProps = {
  children: null,
  isLast: false,
};

class CardWrapper extends Component<Props> {
  static defaultProps = defaultProps;

  render() {
    const {
      children,
      className,
      href,
      image,
      isLast,
      isSelected,
      onClick,
      onMouseEnter,
      onMouseLeave,
      refCallback,
    } = this.props;

    return (
      <div
        ref={refCallback}
        className={cls('CardWrapper', isLast && 'CardWrapperLast')}
      >
        <BpkCard
          href={href}
          blank
          className={cls(
            'CardWrapper__card',
            className,
            isSelected && 'CardWrapper__cardFocus',
          )}
          padded={false}
          atomic={false}
          data-test-id="hotel-card"
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {image && (
            <ResponsibleImage
              className={STYLES.CardWrapper__image}
              name="card-wrapper"
              imageClassName={STYLES.CardWrapper__imageContent}
              image={image}
              sizes={[
                {
                  maxQuery: TABLET_WIDTH,
                  w: 94,
                  h: 77,
                },
                {
                  w: 94,
                  h: 84,
                },
              ]}
            />
          )}
          <div
            className={cls(
              'CardWrapper__content',
              !image && 'CardWrapper__content--noMargin',
            )}
          >
            {children}
          </div>
        </BpkCard>
      </div>
    );
  }
}

export default CardWrapper;
